module.exports = __webpack_public_path__ + "img/tacto_1.d8dd72f9.png";